module.exports = __webpack_public_path__ + "img/shocked.9dfff2ea.png";